import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const ContactsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/contacts" */
    'routes/Contacts/ContactsRoute'
  )
));

const ProfileRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/profile" */
    'routes/Contacts/ProfileRoute'
  )
));

const ProfileActivitiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/profile-activities" */
    'routes/Contacts/ProfileActivitiesRoute'
  )
));

const ProfileAssociationsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/profile-associations" */
    'routes/Contacts/ProfileAssociationsRoute'
  )
));

const ProfileOrdersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/profile-orders" */
    'routes/Contacts/ProfileOrdersRoute'
  )
));

const NonSendableContactsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/non-sendable-contacts" */
    'routes/Contacts/NonSendableContactsRoute'
  )
));

const SuppressedContactsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/suppressed-contacts" */
    'routes/Contacts/SuppressedContactsRoute'
  )
));

const ListsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/lists" */
    'routes/Contacts/ListsRoute'
  )
));

const TagsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/tags" */
    'routes/Contacts/TagsRoute'
  )
));

const SegmentsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/segments" */
    'routes/Contacts/SegmentsRoute'
  )
));

const SegmentTemplatesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/segment-templates" */
    'routes/Contacts/SegmentTemplatesRoute'
  )
));

const UpdateSegmentRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/update-segment" */
    'routes/Contacts/UpdateSegmentRoute'
  )
));

const ActivitiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/activities" */
    'routes/Contacts/ActivitiesRoute'
  )
));

const PredefinedPropertiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/predefined-properties" */
    'routes/Contacts/PredefinedPropertiesRoute'
  )
));

const CustomPropertiesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/custom-properties" */
    'routes/Contacts/CustomPropertiesRoute'
  )
));

const BulkActionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/bulk-actions" */
    'routes/Contacts/BulkActionsRoute'
  )
));

const UpdateBulkActionRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/update-bulk-action" */
    'routes/Contacts/UpdateBulkActionRoute'
  )
));

const BulkActionLogsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/contacts/bulk-action-logs" */
    'routes/Contacts/BulkActionLogsRoute'
  )
));


const getContactsRoutes = () => {
  return [
    {path: paths.getPathContacts(), component: ContactsRoute},
    {path: paths.getPathNonSendableContacts(), component: NonSendableContactsRoute},
    {path: paths.getPathSuppressedContacts(), component: SuppressedContactsRoute},
    {path: paths.getPathContactLists(), component: ListsRoute},
    {path: paths.getPathContactTags(), component: TagsRoute},
    {path: paths.getPathContactProfile(":contactId"), component: ProfileRoute},
    {path: paths.getPathContactProfileActivities(":contactId"), component: ProfileActivitiesRoute},
    {path: paths.getPathContactProfileAssociations(":contactId"), component: ProfileAssociationsRoute},
    {path: paths.getPathContactProfileOrders(":contactId"), component: ProfileOrdersRoute},

    {path: paths.getPathContactSegments(), component: SegmentsRoute},
    {path: paths.getPathSegmentTemplates(), component: SegmentTemplatesRoute},
    {path: paths.getPathAddContactSegment(), component: UpdateSegmentRoute},
    {path: paths.getPathEditContactSegment(":segmentId"), component: UpdateSegmentRoute},
    {path: paths.getPathReplicateContactSegment(":segmentId"), render: (props) => <UpdateSegmentRoute {...props} isReplicate={true} />},
    {path: paths.getPathCreateSegmentFromTemplate(":templateId"), component: UpdateSegmentRoute},

    {path: paths.getPathOnVoardContactActivities(), render: (props) => <ActivitiesRoute {...props} resourceType={constants.RESOURCE_TYPE_ONVOARD} />},
    {path: paths.getPathExternalContactActivities(), render: (props) => <ActivitiesRoute {...props} resourceType={constants.RESOURCE_TYPE_EXTERNAL} />},
    {path: paths.getPathCustomContactActivities(), render: (props) => <ActivitiesRoute {...props} resourceType={constants.RESOURCE_TYPE_CUSTOM} />},

    {path: paths.getPathPredefinedContactProperties(), component: PredefinedPropertiesRoute},
    {path: paths.getPathCustomContactProperties(), component: CustomPropertiesRoute},

    {path: paths.getPathContactsBulkActions(), component: BulkActionsRoute},
    {path: paths.getPathAddContactsBulkAction(), component: UpdateBulkActionRoute},
    {path: paths.getPathEditContactsBulkAction(":bulkActionId"), component: UpdateBulkActionRoute},
    {path: paths.getPathPreviewContactsBulkAction(":bulkActionId"), render: (props) => <UpdateBulkActionRoute {...props} isPreview={true} />},
    {path: paths.getPathContactsBulkActionLogs(":bulkActionId"), component: BulkActionLogsRoute},
  ]
}





export { getContactsRoutes };
